import { render, staticRenderFns } from "./RepoTreeDoc.vue?vue&type=template&id=255075ab&scoped=true"
import script from "./RepoTreeDoc.vue?vue&type=script&lang=js"
export * from "./RepoTreeDoc.vue?vue&type=script&lang=js"
import style0 from "./RepoTreeDoc.vue?vue&type=style&index=0&id=255075ab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "255075ab",
  null
  
)

export default component.exports